import instances from './map';

export const setAuthHeader = instance => (user, password) => {
  // eslint-disable-next-line no-undef
  const token = btoa(`${user}:${password.replace(':', '#dOiS-pOnToS#')}`);
  instances[instance].defaults.headers.Authorization = `Basic ${token}`;
  return token;
};

export const effect = eff => {
  if (!eff.instance) throw new Error('Please, define the instance property.');
  return instances[eff.instance](eff);
};

export const discard = error => {
  const { request, response } = error;
  if (!request) throw error;
  if (!response) return false;
  return response.status >= 400 && response.status < 500;
};
